import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { HankoDialog } from "../../../components/HankoDialog";


interface Props {
  open: boolean
  onClose: () => void
  title: string
  description: React.ReactNode
  buttonText: string
}

export const DeletionNotAllowedModal = (props: Props) => {
  const {title, description, buttonText, onClose} = props

  return <HankoDialog open={props.open} onClose={onClose}>
    <Box maxWidth="500px" sx={{display: "flex", gap: "20px", flexDirection: 'column'}}>
      <Typography variant="h4">{title}</Typography>
      <Typography>{description}</Typography>
      <Button variant="contained" fullWidth onClick={onClose} sx={{mt: 2, mb: 2}}>{buttonText}</Button>
    </Box>
  </HankoDialog>
}